import '../../styles/reset.css';
import _Icon from '../_es/Icon.js';
const treeshaking = (t) => t;
const Icon = treeshaking(_Icon);
export { Icon };